<template>
  <div class="container-fluid ">
    <div class="row header-panel nav-alt">
      <div class="col-3 left_side">
        <div class="login_logo_wrapper">
          <span>v2.0</span>
        </div>
      </div>
      <div class="col-9 right_side">
        <NavItem/>
      </div>

    </div>
    <div class="row content-panel content d-flex justify-content-between">

      <div class="col-12 ">
        <tabs class="d-flex flex-column align-items-start" :options="{ defaultTabHash: 'first-tab' }">
          <tab id="first-tab" name="პირადი ინფორმაცია">
            <div class="d-flex tab-container">
              <EditUserInformation />
            </div>
          </tab>
          <tab v-if="showUsersTab" id="second-tab" name="მომხმარებლები">
            <div class="d-flex tab-container">
              <UsersItem />
            </div>
          </tab>
          <tab v-if="showAlertsTab" id="third-tab" name="განგაშები">
            <div class="d-flex tab-container">
              <AlertItem />
            </div>
          </tab>
        </tabs>
      </div>
    </div>
  </div>

</template>

<script>
import NavItem from "@/components/partials/NavItem";
import {Tabs, Tab} from 'vue3-tabs-component';
import EditUserInformation from "@/components/profile/EditUserInformation";
// import UsersItem from "@/components/profile/UsersItem";
import AlertItem from "@/components/alert/AlertItem";
import UsersItem from "@/components/profile/UsersItem.vue";

export default {
  name:"ReportsItem",
  components:{
		UsersItem,
    AlertItem,
    EditUserInformation,
    // UsersItem,
    NavItem, Tabs, Tab
  },
	computed: {
		me(){
			if (!this.$store.state.user.me) {
				return false;
			}
			return this.$store.state.user.me.data
		},
		showUsersTab() {
			if (!this.me) {
				return false;
			}
			return this.me.rolleid === 0 || (this.me.permissions && this.me.permissions[1] && this.me.permissions[1].write);
		},
		showAlertsTab() {
			if (!this.me) {
				return false;
			}
			return this.me.rolleid === 0 || (this.me.permissions && this.me.permissions[2] && this.me.permissions[2].write);
		}
	}

}
</script>

<style>
/*.fit-container{*/
/*  padding-left: 30px;*/
/*  padding-right: 30px;*/
/*}*/


.tabs-component{
  border-top: none;
  border-radius: 10px;
  padding: 20px 0 0 10px;
}

.tabs-component-panels{
  border: 1px solid var(--border-color);
  border-top:0;
  width: 100%;
  margin-left: -10px;
  border-radius: 5px;
  border-top-left-radius: 0;
}

.tabs-component-tabs{
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  margin-left: -10px;
  margin-bottom: 0;
  border-bottom: 1px solid var(--border-color);

}

.tabs-component-tabs > .tabs-component-tab{
  padding: 10px 10px 10px 0;
  border: 1px solid var(--border-color);
  border-bottom: 0;

  background-color: var(--tab-bg);
  list-style-type: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}


.tabs-component-tabs > .tabs-component-tab.is-active{
  background-color: #FFFFFF;
  border-bottom: 0;
  margin-bottom: -1px;
}

.tabs-component-tabs > .tabs-component-tab:not(:first-child) {
  margin-left: 15px;
}

.tab-container{
  /*padding:15px;*/
  text-align: left;
  font-family: "TBCDinNusxuri-Medium";
}

.tab-header{
  width: 100%;
}


</style>